<div class="card flex justify-center">
<p-drawer #drawerRef [(visible)]="visible">
    <ng-template #headless>
        <div class="flex flex-col h-full bg-primary border-none">
            <div class="flex items-center justify-between px-6 pt-4 shrink-0">                                 
                <span class="font-semibold text-2xl text-black">
                    ACTOR
                </span>                
                <span>
                    <p-button type="button" (click)="closeCallback($event)" icon="pi pi-times" rounded="true" outlined="true" styleClass="h-6 w-6" severity="contrast"></p-button>
                </span>
            </div>
            <div class="overflow-y-auto">
                <ul class="list-none p-4 m-0">
                    <li>
                        <div
                            pRipple
                            pStyleClass="@next"
                            enterFromClass="hidden"
                            enterActiveClass="animate-slidedown"
                            leaveToClass="hidden"
                            leaveActiveClass="animate-slideup"
                            class="p-4 flex items-center justify-between text-black dark:text-surface-200 cursor-pointer p-ripple"
                        >
                            <span class="font-medium">Compliance Evaluation</span>
                            <i class="pi pi-chevron-down"></i>
                        </div>
                        <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a pRipple routerLink="/new-analysis" class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-700 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple">
                                    <i class="pi pi-home mr-2 text-surface-100"></i>
                                    <span class="font-medium text-surface-100">New Analysis</span>
                                </a>
                            </li>
                            <!-- <li>
                                <a pRipple routerLink="/app-results" class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-700 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple">
                                    <i class="pi pi-chart-line mr-2 text-surface-100"></i>
                                    <span class="font-medium text-surface-100">Results</span>
                                </a>
                            </li> -->
                        </ul>
                    </li>
                </ul>
                <ul class="list-none p-4 m-0">
                    <li>
                        <div
                            pRipple
                            pStyleClass="@next"
                            enterFromClass="hidden"
                            enterActiveClass="animate-slidedown"
                            leaveToClass="hidden"
                            leaveActiveClass="animate-slideup"
                            class="p-4 flex items-center justify-between text-black dark:text-surface-200 cursor-pointer p-ripple"
                        >
                            <span class="font-medium">Dashboards</span>
                            <i class="pi pi-chevron-down"></i>
                        </div>
                        <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a pRipple routerLink="/manuals-dashboard" class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-700 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple">
                                    <i class="pi pi-folder mr-2 text-surface-100"></i>
                                    <span class="font-medium text-surface-100">Uploaded Manuals</span>
                                </a>
                            </li>
                            <li>
                                <a pRipple routerLink="/jobs-dashboard" class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-700 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple">
                                    <i class="pi pi-chart-bar mr-2 text-surface-100"></i>
                                    <span class="font-medium text-surface-100">Jobs</span>
                                </a>
                            </li>                            
                        </ul>
                    </li>
                </ul>
                <ul class="list-none p-4 m-0">
                    <li>
                        <div pRipple pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-slidedown"
                            leaveToClass="hidden" leaveActiveClass="animate-slideup"
                            class="p-4 flex items-center justify-between text-black dark:text-surface-200 cursor-pointer p-ripple">
                            <span class="font-medium">Settings</span>
                            <i class="pi pi-chevron-down"></i>
                        </div>
                        <ul class="list-none p-0 m-0 overflow-hidden">
                            <li>
                                <a pRipple routerLink="/manage-users"
                                    class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-700 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple">
                                    <i class="pi pi-pen-to-square mr-2 text-surface-100"></i>
                                    <span class="font-medium text-surface-100">Manage Users</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>            
        </div>
    </ng-template>
</p-drawer>
<p-button (click)="visible = true" icon="pi pi-bars" />
</div>
